module.exports = __webpack_public_path__ + "img/login-app.33db7866.png";